import React from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import { useLocation, useNavigate } from 'react-router-dom';

import { Template } from 'devextreme-react/core/template';

import { UserPanel } from '../user-panel/UserPanel';
import { ThemeSwitcher } from '../theme-switcher/ThemeSwitcher';

import type { AppHeaderProps } from '../../../types';

import './AppHeader.scss';
import { navigation } from '../../../app-navigation';
import { useScreenSize } from '../../../utils/media-query';

export const AppHeader = ({ title, className }: AppHeaderProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isSmall, isXSmall } = useScreenSize();
  const compact = isSmall || isXSmall;

  return (
    <header className={`header-component ${className}`}>
      <img className='header-factory-art' src='/factory-line-art.svg' alt='' aria-hidden='true' draggable={false} />
      <Toolbar className='header-toolbar'>
        <Item location='before' cssClass='header-brand' template='headerBrandTemplate' visible={!!title} />
        {navigation.map(({ text, path }) => {
          const active = pathname === path || pathname.startsWith(`${path}-`);
          return (
            <Item key={path} visible={!compact} location='after' locateInMenu='never' cssClass={`primary-nav-link${active ? ' active' : ''}`}>
              <Button text={text} hint={text} stylingMode='text' onClick={() => navigate(path)} />
            </Item>
          );
        })}
        <Item location='after' locateInMenu='never'>
          <ThemeSwitcher />
        </Item>
        <Item location='after' locateInMenu='never'>
          <div className='messages'>
            <Button icon='belloutline' hint='Thông báo' elementAttr={{ 'aria-label': 'Thông báo' }} stylingMode='text' />
          </div>
        </Item>
        <Item location='after' locateInMenu='never' menuItemTemplate='userPanelTemplate'>
          <UserPanel menuMode='context' />
        </Item>
        <Template name='userPanelTemplate'>
          <UserPanel menuMode='list' />
        </Template>
        <Template name='headerBrandTemplate'>
          <img className='header-brand-logo' src='/logo-vicem-bim-son.png' alt={title} />
        </Template>
      </Toolbar>
    </header>
  );
};
